import { Button, Divider, Space } from 'antd';
import { useCallback } from 'react';
import { useLogout } from '../../../api';
import { useIsAdminRole } from '../../../utils/hooks/useIdentityAdmin.hook';
import { useUserDetails } from '../../pages/auth/components/auth/hooks';
import './userDetails.css';

const UserDetailsItem = ({ item, value }: { item: string; value?: string | number }) => (
  <div className={'user-details__item'}>
    <span>{item}</span>: {value ?? ''}
  </div>
);

const UserDetails = () => {
  const { email, fullName, userId, id } = useUserDetails();
  const isAdminRole = useIsAdminRole();
  const { mutate: logout } = useLogout({
    onSuccess: () => {
      window.location.href = "/app/login";
      localStorage.clear();
    },
  });

  const onLogout = useCallback(() => {
    logout();
  }, [logout]);

  return (
    <Space className={'user-details'}>
      <div className={'user-details__item user-details-title'}>{isAdminRole ? 'Admin' : 'User'} details</div>
      <Divider className={'user-details__divider'} />
      <div className={'user-details-content'}>
        <UserDetailsItem item={'Email'} value={email} />
        <UserDetailsItem item={'Name'} value={fullName} />
        <UserDetailsItem item={'SMART UID'} value={userId} />
        <UserDetailsItem item={'ID'} value={id} />
      </div>
      <Divider className={'user-details__divider'} />
      <Space className={'user-details__item'}>
        <Button type='link' danger className={'user-details__logout'} onClick={onLogout}>
          Log out
        </Button>
      </Space>
    </Space>
  );
};
export default UserDetails;
